import Axios from 'axios';

Axios.defaults.baseURL = 'https://newinv.musafirbazar.com/apiC/';
// Axios.defaults.baseURL = 'https://flight.marinersforex.com/api/';

export const axiosInstance = Axios.create({});
